<div class="mainLoader" *ngIf="loading==true">
  <div class="loader"></div>
</div>

<div class="loginModule">
  <div class="loginWrapper">
    <div class="loginWrapperLeft">
      <a href="/" class="loginLogo"><img src="../../assets/logoSmall.svg" /></a>
      <h3>Sign UP</h3>


      <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()" >
        <div class="form-group">
          <label for="email" class="form-label">Email Address</label>
          <input type="email" class="form-control" id="email" placeholder="" formControlName="email"
                 [ngClass]="{'invalid': submitted && f['email'].invalid}" />
          <div *ngIf="submitted && f['email'].invalid">
            <p style="color: red;">
              Please provide a valid Email.
            </p>
          </div>
        </div>
        
        <div class="buttonGroup d-grid">
          <button type="submit" class="btn btn-secondary w-100">Sign Up</button>
          <hr />
        </div>
      </form>
      
      <div class="buttonGroup d-grid">

        <button type="button" class="btn btn-light  w-100" (click)="login()">Log in</button>
      </div>

    </div>
    <div class="loginWrapperRight d-none d-sm-inline-flex">
      <figcaption>
        <h1 class="font_med">Welcome to PharmaVision</h1>
        <h5>
          AI based one stop shop for capture, vet, and distributing insights in real-time
        </h5>
      </figcaption>
    </div>
  </div>
  <p class="forgotPassword mt-3">
    Forgot your password? <a href="javascript:void(0)" [routerLink]="['/forgot-password']">Get a new password</a>
  </p>
</div>
<!--</ng-template>-->
